import { UNLOCK_VOD_CONTENT, CLEAR_UNLOCK_VOD_CONTENT } from './constants';

export const unLockVodContentbyGroudId = groupId => dispatch => {
  dispatch({
    type: UNLOCK_VOD_CONTENT,
    payload: groupId,
  });
};

export const clearUnLockVodContentbyGroudId = groupId => dispatch => {
  dispatch({
    type: CLEAR_UNLOCK_VOD_CONTENT,
  });
};
